// Identity helper – pamatuje si inzeráty, které jsem vložil/odemkl na tomto zařízení.
// Tím STAVBOŠ pozná, že jsem majitel inzerátu (skryje chat, předvyplní auth).
const KEY = "stb_my_ads";
const EMAIL_KEY = "stb_user_email";
/** Jak dlouho držíme manage_token na zařízení (ms). */
const TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 dní

function readMap() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch (_) {
    return {};
  }
}

function writeMap(m) {
  try {
    localStorage.setItem(KEY, JSON.stringify(m));
  } catch (_) {}
}

function isExpired(entry) {
  if (!entry) return true;
  const saved = entry.saved_at ? Date.parse(entry.saved_at) : NaN;
  if (!Number.isFinite(saved)) return false; // legacy entries bez data – necháme, obnoví se při dalším unlocku
  return Date.now() - saved > TTL_MS;
}

/** Odstraní prošlé záznamy; vrací aktuální mapu. */
function pruneMap(m) {
  let changed = false;
  const next = { ...m };
  for (const [id, entry] of Object.entries(next)) {
    if (isExpired(entry)) {
      delete next[id];
      changed = true;
    }
  }
  if (changed) writeMap(next);
  return next;
}

export function rememberMyAd(listingId, data = {}) {
  if (!listingId) return;
  const m = pruneMap(readMap());
  m[listingId] = {
    ...m[listingId],
    ...data,
    saved_at: new Date().toISOString(),
  };
  writeMap(m);
  if (data.contact_email) {
    try {
      localStorage.setItem(EMAIL_KEY, data.contact_email);
    } catch (_) {}
  }
}

export function forgetMyAd(listingId) {
  const m = readMap();
  delete m[listingId];
  writeMap(m);
}

/** Zapomene všechny odemčené inzeráty na tomto zařízení. */
export function forgetAllMyAds() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}

export function getSavedUserEmail() {
  try {
    return localStorage.getItem(EMAIL_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function isMyAd(listingId) {
  const m = pruneMap(readMap());
  return !!m[listingId];
}

export function getMyAd(listingId) {
  const m = pruneMap(readMap());
  const e = m[listingId];
  return e && !isExpired(e) ? e : null;
}

/**
 * Auth body pro API (token z localStorage).
 * Heslo se záměrně neukládá – po unlocku vždy persistujeme manage_token.
 */
export function getMyAdAuth(listingId) {
  const e = getMyAd(listingId);
  if (!e?.manage_token) return null;
  return { token: e.manage_token };
}

export function listMyAds() {
  const m = pruneMap(readMap());
  return Object.entries(m).map(([id, v]) => ({ listing_id: id, ...v }));
}
